import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get_support_faq, getSupportMeta } from '../../Apis/content';

export const GetSupportFaq = createAsyncThunk('GetSupportFaq', async (type, { rejectWithValue }) => {

    try {
        const response = await get_support_faq(type);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});



const supportfaqSlice = createSlice({
    name: 'supportfaq',
    initialState: {
        error: null,
        success: false,
        data: [],


    },
    reducers: {
        clearSupportFaqStatus: state => {
            state.success = false;
            state.error = null;
        },

    },
    extraReducers: builder => {
        builder

            .addCase(GetSupportFaq.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetSupportFaq.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(GetSupportFaq.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            // .addCase(GetSupportMetaDetails.pending)

    },

});
export const { clearSupportFaqStatus } = supportfaqSlice.actions;
export default supportfaqSlice.reducer;

